module.exports = __webpack_public_path__ + "img/BNP.1084ee42.png";